import script from "./quicklinkComposer.vue?vue&type=script&lang=js"
export * from "./quicklinkComposer.vue?vue&type=script&lang=js"

import "./quicklinkComposer.vue?vue&type=style&index=0&id=586fe1ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586fe1ce"]])

export default __exports__